import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { warehouseService } from '@kss/api';
import type { WarehouseCreate } from '@kss/api';
import { loadStoreOptions } from '../shared/formLoaders';

const columns: BulkColumn<WarehouseCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Central Warehouse' },
  { key: 'code', header: 'Code', sample: 'WH-001' },
  { key: 'address', header: 'Address' },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkWarehouse() {
  return (
    <BulkSpreadsheet<WarehouseCreate> title="Bulk import warehouses" entityLabel="warehouse" backPath="/panel/warehouses" columns={columns} module="Warehouse"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await warehouseService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
